module.exports = __webpack_public_path__ + "static/media/CG.9f022f33.svg";